import React, { useEffect } from "react";
import {
  AboutFounderSection,
  AboutSlider,
  LastingImpactSection,
  LeadershipPrinciplesSection,
  OurTeamSection,
} from "../../components/about";
import { ProgramsHeroSection } from "../../components/programs";
import { WhyCatalyzeSection } from "../../components/institution";
import aboutData from "../../data/aboutData.json";
import "../programs/program.css";
import "./about.css";

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="about-page">
      <ProgramsHeroSection data={aboutData.hero} className="about-page-hero" />
      
      <WhyCatalyzeSection data={aboutData.vision} className="about-page-vision" />
      <AboutSlider images={aboutData.slider} />
      <AboutFounderSection data={aboutData.founder} />
      {/* <LeadershipPrinciplesSection data={aboutData.leadershipPrinciples} /> */}
      <LastingImpactSection data={aboutData.lastingImpact} />
      <OurTeamSection data={aboutData.team} />
    </main>
  );
}
